import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import '@mdi/font/css/materialdesignicons.css';

import pl from 'vuetify/src/locale/pl';

Vue.use(Vuetify, {
  theme: {
    primary: '#009688',
    secondary: '#4caf50',
    tertiary: '#495057',
    accent: '#82B1FF',
    error: '#f55a4e',
    info: '#00d3ee',
    success: '#5cb860',
    warning: '#ffa21a'
  },
  iconfont: 'mdi',
  lang: {
    locales: { pl },
    current: 'pl'
  }
});
